import React from 'react';

import Avatar from '@/ui/components/Avatar';
import Tooltip from '@/ui/components/Tooltip/Tooltip';

interface MemberProfile {
  avatarUrl?: string;
  name?: string;
}

interface AvatarStackProps {
  members: MemberProfile[];
  maxAvatars?: number;
}

const AvatarStack: React.FC<AvatarStackProps> = ({ members, maxAvatars = 5 }) => {
  const displayedMembers = members.slice(0, maxAvatars);
  const extraCount = Math.max(0, members.length - maxAvatars);

  const tooltipContent = (
    <div className="text-sm">
      <div className="font-medium mb-1">Participants ({members.length})</div>
      {members.map((member, index) => {
        const name = member.name || 'User';
        return <div key={index}>{name}</div>;
      })}
    </div>
  );

  return (
    <Tooltip tooltipContent={tooltipContent}>
      <div className="flex -space-x-2">
        {displayedMembers.map((member, index) => {
          const avatarUrl = member.avatarUrl;
          const name = member.name || 'User';

          return <Avatar key={index} avatarUrl={avatarUrl} name={name} size="medium" />;
        })}
        {extraCount > 0 && (
          <div className="w-8 h-8 rounded-full bg-gray-300 border-2 border-white flex items-center justify-center text-xs font-medium text-gray-700 shadow-sm">
            +{extraCount}
          </div>
        )}
      </div>
    </Tooltip>
  );
};

export default AvatarStack;
